/**
 * @module app.cm
*/

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { CaseService } from 'app/cm/services/case-service';
import { apiCall } from 'app/shared/lib/api/api';
import { ICaseAuditLogModelData } from 'app/cm/components/audit-log/case-audit-log';
import * as CM from 'app/cm/models/essette-api'

@autoinject()
export class CaseAuditLogPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected case: CM.Case | null = null;
    protected modelData: ICaseAuditLogModelData | null = null;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly caseService: CaseService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('cm.case.audit-log');
    }

    protected async activate(params: { caseId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.caseId) throw new Error('Missing required parameters: caseId');

        await this.reload(params.caseId);

        if(this.case && routeConfig?.navModel) {
            const title = this.i18n.tr('cm:routes.case.audit-log.$title', { number: this.case.number });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////
    protected async reload(caseId: string): Promise<void> {
        if(!caseId) return;

        await this.loadCase(caseId);
        if(!this.case) {
            throw new Error('Unable to load case');
        }

        this.modelData = {
            case: this.case
        };
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCase(caseId: string): Promise<void> {
        if(!caseId) return;

        try {
            this.state.beginLoad();

            const response = await this.caseService.loadCase(caseId);
            this.case = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
